import React, { useEffect, useState } from "react";
import { MapPinned, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import api, { apiError } from "@/lib/api";
import { useLang } from "@/i18n";
import { Panel, openFile, EmptyInline } from "@/pages/shared";
import MobileAppPanel from "@/components/MobileAppPanel";

export default function AdminMap() {
  const { t } = useLang();
  const [maps, setMaps] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = async () => {
    try { setMaps((await api.get("/files?category=map")).data); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("category", "map");
    try { await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); await load(); toast.success(t("saved")); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setUploading(false); }
  };

  const remove = async (id) => {
    try { await api.delete(`/files/${id}`); await load(); toast.success(t("deleted")); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
      <Panel title={t("map_update")} testid="admin-map-update-panel">
        <div className="p-5 space-y-3">
          <p className="text-sm text-muted-foreground">{t("map_update_desc")}</p>
          <Button asChild data-testid="open-map-update"><Link to="/admin/kaart"><MapPinned className="h-4 w-4 mr-2" />{t("map_update")}</Link></Button>
        </div>
      </Panel>

      <Panel title={t("camping_map")} testid="admin-map-panel">
        <div className="p-5 space-y-4">
          <label className="flex flex-col items-center justify-center gap-2 border-2 border-dashed border-border rounded-lg py-8 cursor-pointer hover:border-primary transition-colors" data-testid="map-upload-label">
            <MapPinned className="h-7 w-7 text-primary" />
            <span className="text-sm text-muted-foreground">{uploading ? "…" : t("upload_map")}</span>
            <span className="text-[11px] text-muted-foreground">PNG, JPG of PDF</span>
            <input type="file" accept="image/*,.pdf" className="hidden" onChange={upload} data-testid="map-upload-input" />
          </label>
          <div className="space-y-2">
            {maps.length === 0 ? <EmptyInline /> :
              maps.map((m) => (
                <div key={m.id} className="flex items-center justify-between border border-border rounded-lg px-3 py-2">
                  <button className="text-sm text-primary hover:underline truncate" onClick={() => openFile(api, m.id)} data-testid={`map-file-${m.id}`}>{m.original_filename}</button>
                  <Button variant="ghost" size="sm" onClick={() => remove(m.id)}><Trash2 className="h-4 w-4 text-rose-500" /></Button>
                </div>
              ))}
          </div>
        </div>
      </Panel>

      <MobileAppPanel />
    </div>
  );
}
